import styled from 'styled-components';
import { space } from 'styled-system';
export default styled.hr.withConfig({
  displayName: "hr",
  componentId: "sc-mxh4u4-0"
})(["background-color:#dbdbdb;height:1px;margin:1.5rem 0;border:none;", ""], space);